import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Confirmation, ConfirmationService, MessageService, ToastMessageOptions } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { AppService } from './services/app.service';

@Component({
	selector: 'app-root',
	imports: [
		RouterOutlet,
    ToastModule,
    ConfirmDialogModule,
	],
	templateUrl: './app.component.html',
  providers: [
    MessageService,
    ConfirmationService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  private appService = inject(AppService);

  ngOnInit(): void {
    const theme = localStorage.getItem('beoexpo_theme') || 'light';
    this.appService.switchTheme(theme);

    this.appService
      .toast
      .subscribe(
        (message: ToastMessageOptions|null) => {
          if (message) {
            this.messageService.add(message);
          }
        }
      );
      
    this.appService
      .dialog
      .subscribe(
        (dialog: Confirmation|null) => {
          if (dialog) {
            this.confirmationService.confirm(dialog);
          }
        }
      );
  }

}
